import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Maps an LLM model id (e.g. "google/gemini-2.0-flash-001") to its display
// name, given the models list returned by GET /api/models. Falls back to the
// raw id if the model isn't found (e.g. list still loading).
export function getModelDisplayName(models, modelId) {
  const match = (models || []).find((m) => m.id === modelId);
  return match ? match.name : modelId;
}
